import { useQueries, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { getCalculatedCropFootprintByCropIdAndYear } from "services";

import { getLocalKlimVar, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_CROP_CALCULATED_FOOTPRINT } from "consts";

export const useGetFootprintingCalculatedCropFootprints = (farmId?: string, years: number[] = [], cropIds: string[] = [], { enabled = true } = {}) => {
  const queryClient = useQueryClient();
  const { user } = useUserContext();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getLocalKlimVar("token");

  const allYearCropIdCombos = years.flatMap((year) => cropIds.map((cropId) => ({ year, cropId })));

  return useQueries({
    queries: allYearCropIdCombos.map(({ year, cropId }) => ({
      queryKey: [FOOTPRINTING_CROP_CALCULATED_FOOTPRINT, farmId, cropId, year],
      queryFn: () => getCalculatedCropFootprintByCropIdAndYear(cropId, year),
      enabled: enabled && !!farmId && !!cropId && !!year && !!user && !!token && !!carbonProgram?.platformFeatures?.footprinting?.enabled,
      queryClient,
      gcTime: 60000,
      retry: (_: number, error: Error) => {
        if (error instanceof AxiosError && (error.response?.status === 404 || error.response?.status === 418)) {
          return false;
        }
        return true;
      },
    })),
  });
};
